import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import DeleteIcon from "@mui/icons-material/Delete";

// import JS files
import useFetch from "../../../../context/useFetch";
import MuiUpload from "../../../shares/MuiUpload";
import MuiButton from "../../../shares/MuiButton";
import MuiTextFieldHook from "../../../shares/MuiTextFieldHook";
import MuiSelectHook from "../../../shares/MuiSelectHook";
import RingsSizeEdit from "./RingsSizeEdit";
import { ageList, colorList, fixNumbers } from "../../../../utils";
import MuiComboBox from "../../../shares/MuiComboBox";

// import Others files
import sampleImg from "../../../../imgs/sample-ring.png";

const EditRingForm = (props) => {
  let windowWidth = window.screen.width;

  const [imageFile, setImageFile] = useState(undefined);
  const [postValues, setPostValues] = useState();

  const {
    register,
    handleSubmit,
    watch,
    setError,
    control,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    defaultValues: {
      name: props.item.show_name,
      brand: props.item.brand,
      code: props.item.code,
      age: props.item.gender,
      color: props.item.color,
      weight1: props.item.size_one_weight,
      weight2: props.item.size_two_weight,
      weight3: props.item.size_three_weight,
      weight4: props.item.size_four_weight,
      weight5: props.item.size_five_weight,
      weight6: props.item.size_six_weight,
    },
  });

  const [brandPagination, setBrandPagination] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
    next: null,
    previous: null,
  });

  const [brandsList, setBrandsList] = useState({ results: [] });
  const getBrandsApi = useFetch({
    method: "get",
    url: "Brand_Service",
    trigger: true,
    pagination: brandPagination,
    setter: setBrandsList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const [searchedProducerText, setSearchedProducerText] = useState("");
  const [producersList, setProducersList] = useState({
    results: [],
  });

  const getProvidersApi = useFetch({
    method: "get",
    url: "Provider_Service",
    params: { name: searchedProducerText },
    trigger: false,
    argFunc: (res) => {
      setProducersList(res);
    },
    errMessage: (mess) => {
      toast.error("خطا در برقراری ارتباط با سرور", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const handleSearchedProducerText = (text) => {
    setSearchedProducerText(text);
    if (text.length >= 1) {
      getProvidersApi.reFetch();
    }
  };

  const [selectedProducer, setSelectedProducer] = useState(undefined);
  const [selectedProducersList, setSelectedProducersList] = useState(
    props.item.providers
  );

  const handleSelectedProducersList = () => {
    if (
      selectedProducersList.filter((ite) => ite.id == selectedProducer)
        .length == 0
    ) {
      setSelectedProducersList([
        ...selectedProducersList,
        producersList.results.filter((it) => it.id == selectedProducer)[0],
      ]);
      setSelectedProducer();
      setProducersList({ results: [] });
    }
  };

  const removeSelectedProducersList = (id) => {
    setSelectedProducersList(
      selectedProducersList.filter((it) => it.id !== id)
    );
    setSelectedProducer(undefined);
  };

  const EditRingApi = useFetch({
    method: "patch",
    url: `Bangle_Service/${props.item.id}`,
    trigger: false,
    data: postValues,
    caller: props.getFunc,
    argFunc: (res) => {
      props.getRingsApi.reFetch();
      props.setOpenModal(false);
      reset();
      // toast.success("النگو موردنظر با موفقیت ویرایش شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const onSubmit = (data) => {
    if (imageFile !== undefined) {
      data["img"] = imageFile;
    }

    let providersList = [];
    selectedProducersList.filter((item) => {
      providersList.push(item.id);
    });

    let formData = new FormData();

    formData.append("show_name", data.name);
    formData.append("brand", data.brand);

    if (imageFile !== "img_is_deleted") {
      if (imageFile !== undefined) {
        formData.append("attach_file", data.img, data.img.name);
      }
    }

    formData.append("code", fixNumbers(data.code));
    formData.append("gender", data.age);
    formData.append("color", data.color);
    for (var i = 0; i < providersList.length; i++) {
      formData.append("provider", parseInt(providersList[i]));
    }

    formData.append("size_one_weight", data.weight1);
    formData.append("size_two_weight", data.weight2);
    formData.append("size_three_weight", data.weight3);
    formData.append("size_four_weight", data.weight4);
    formData.append("size_five_weight", data.weight5);
    formData.append("size_six_weight", data.weight6);

    setPostValues(formData);
    EditRingApi.reFetch();
  };

  const deleteImgApi = useFetch({
    method: "get",
    url: `Bangle_Service/${props.item.id}/delete_bangle_image`,
    argFunc: (res) => {
      setImageFile("img_is_deleted");
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const handleDeleteImg = () => {
    deleteImgApi.reFetch();
  };

  return (
    <>
      <div className=" grid gap-x-2 mt-4">
        <div className="border p-4 md:col-span-2 rounded-md">
          <form className="" onSubmit={handleSubmit(onSubmit)}>
            <div className="grid md:grid-cols-2 gap-y-6 gap-x-4 border-dashed border-b pb-4">
              <div className="">
                <MuiTextFieldHook
                  id="outlined-basic"
                  label="نام"
                  variant="outlined"
                  size="small"
                  name="name"
                  control={control}
                  register={{
                    required: {
                      value: true,
                      message: "نام را وارد کنید.",
                    },
                  }}
                />
              </div>

              <div>
                <MuiSelectHook
                  size="small"
                  inputLabel="برند"
                  label="Brand"
                  control={control}
                  name="brand"
                  register={{
                    required: {
                      value: true,
                      message: "برند را انتخاب کنید",
                    },
                  }}
                  labelId="brand-label"
                  id="brand-select"
                  menuItems={brandsList.results}
                  fromApi={true}
                />
              </div>
            </div>
            <div className=" rounded-md grid md:grid-cols-2">
              <div className="">
                <div className="mt-2 flex justify-center">
                  {imageFile instanceof File ? (
                    <img
                      className="w-20 h-20 md:w-32 md:h-32 rounded-full"
                      src={URL.createObjectURL(imageFile)}
                    />
                  ) : props.item.attach_file == "EMPTY" ||
                    imageFile == "img_is_deleted" ? (
                    <img
                      className="w-20 h-20 md:w-32 md:h-32 rounded-full"
                      src={sampleImg}
                    />
                  ) : (
                    <>
                      <div className="relative">
                        <img
                          className="w-20 h-20 md:w-32 md:h-32 rounded-full"
                          src={props.item.attach_file}
                        />
                        <div className="lite-close-modal-icon absolute top-0 left-0">
                          <DeleteIcon onClick={handleDeleteImg} />
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div className="mt-4">
                  <MuiUpload setImageFile={setImageFile} />
                </div>
                <div className="mt-6">
                  <MuiTextFieldHook
                    id="outlined-basic"
                    label="کد"
                    variant="outlined"
                    size="small"
                    name="code"
                    control={control}
                    register={{
                      required: {
                        value: true,
                        message: "کد را وارد کنید.",
                      },
                    }}
                  />
                </div>
                <div className="mt-6">
                  <MuiSelectHook
                    size="small"
                    inputLabel="سن"
                    label="Age"
                    control={control}
                    name="age"
                    register={{
                      required: {
                        value: true,
                        message: "سن را انتخاب کنید",
                      },
                    }}
                    labelId="woman-girl-label"
                    id="woman-girl-select"
                    menuItems={ageList}
                    fromApi={false}
                  />
                </div>
                <div className="mt-6">
                  <MuiSelectHook
                    size="small"
                    inputLabel="رنگ"
                    label="Color"
                    control={control}
                    name="color"
                    register={{
                      required: {
                        value: true,
                        message: "رنگ را انتخاب کنید",
                      },
                    }}
                    labelId="color-label"
                    id="color-select"
                    menuItems={colorList}
                    fromApi={false}
                  />
                </div>
                <div className="grid md:grid-cols-4 gap-x-4 items-center mt-4">
                  <span className="md:col-span-2 text-sm md:text-base ">
                    تولیدکنندگانی که این النگو را تولید می‌کنند:
                  </span>

                  <div className="mt-2 md:mb-0">
                    <MuiComboBox
                      size="small"
                      label="تولیدکننده"
                      forUser
                      name="provider"
                      labelId="provider-search-label"
                      id="provider-search-select"
                      options={producersList.results}
                      placeholder="تولیدکننده"
                      setSelectedOption={setSelectedProducer}
                      setSearchText={handleSearchedProducerText}
                    />
                  </div>

                  <div className="mt-2 md:mb-0 text-center md:text-left">
                    <MuiButton
                      onClick={handleSelectedProducersList}
                      variant="contained"
                      //     icon={<AddIcon />}
                      color="primary"
                      text="افزودن به لیست"
                      disabled={selectedProducer == undefined}
                    />
                  </div>
                </div>
                {selectedProducersList.length > 0 && (
                  <div className="p-2 border mt-2 bg-gray-100 rounded-lg flex flex-wrap">
                    {selectedProducersList.map((item, index) => {
                      return [
                        <div className="bg-white rounded-lg py-1 px-2 m-2">
                          <span>{item.name}</span>
                          <CloseIcon
                            onClick={() => removeSelectedProducersList(item.id)}
                            className="delete-icon mr-2"
                          />
                        </div>,
                      ];
                    })}
                  </div>
                )}
              </div>
              <div className="">
                <div className="mt-4">
                  <RingsSizeEdit
                    control={control}
                    register={{
                      required: {
                        value: false,
                        message: "وزن را وارد کنید.",
                      },
                    }}
                  />
                </div>
              </div>
              <div></div>
              <div className=" flex justify-end w-full mt-2">
                <MuiButton
                  withoutOnClick
                  type="submit"
                  variant="contained"
                  icon={<EditIcon />}
                  color="primary"
                  text="ویرایش"
                  disabled={
                    EditRingApi.loading || selectedProducersList.length <= 0
                  }
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditRingForm;
